import React, { useState, useEffect } from "react";
import { Box, Center, Flex, Text, Slider, SliderTrack, SliderFilledTrack, SliderThumb, Spacer, VStack, useControllableState } from "@chakra-ui/react";

interface Props {
  sliderName: string;
  initialValue: number;
  callback?: any;
  reset: boolean;
}

const SliderBar: React.FC<Props> = ({sliderName, initialValue, callback, reset}: Props) => {
  const [sliderValue, setSliderValue] = useState(initialValue);

  const [internalValue, setInternalValue] = useControllableState({
    value: sliderValue,
    onChange: setSliderValue,
  });

  const changeValue = (value: number) => {
    console.log("value is", value);
    setInternalValue(value);
    if (callback) {
      callback(value);
    } else {
      console.log("callback doesn't exist");
    }
  };

  useEffect(() => {
    console.log("reset useEffect called");
    setInternalValue(initialValue);
  },[reset]);

  return (
    <VStack align="left">
      <Text>
        {sliderName}
      </Text>
      <Flex width="100%">
        <Slider onChange={(value) => changeValue(value)} width="80%" value={internalValue}>
          <SliderTrack>
            <SliderFilledTrack/>
          </SliderTrack>
          <SliderThumb bgColor="blue.500"/>
        </Slider>
        <Spacer/>
        <Box outlineColor="gray.500" borderWidth="1px" p="3px" width="15%" borderRadius="6px">
          <Center>
            {internalValue}
          </Center>
        </Box>
      </Flex>
    </VStack>
  );
};

export default SliderBar;